"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Paragraph = _interopRequireDefault(require("../misc/Paragraph"));
var _PageTitle = _interopRequireDefault(require("./PageTitle"));
var _TitleWithButton = _interopRequireDefault(require("./TitleWithButton.style"));
var _excluded = ["title", "button", "paragraph", "wrapTitle", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TitleWithButton = function TitleWithButton(_ref) {
  var title = _ref.title,
    button = _ref.button,
    paragraph = _ref.paragraph,
    wrapTitle = _ref.wrapTitle,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_TitleWithButton["default"], otherProps, /*#__PURE__*/_react["default"].createElement(_PageTitle["default"], {
    id: "pageTitle",
    title: title,
    wrapTitle: wrapTitle
  }), button, paragraph && /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], null, paragraph), children);
};
TitleWithButton.defaultProps = {
  title: '',
  button: null,
  paragraph: null,
  wrapTitle: false,
  children: null
};
TitleWithButton.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].string,
  button: _propTypes["default"].node,
  paragraph: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  wrapTitle: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(TitleWithButton);